import styled from "styled-components";

const Anchor = styled.a`
  color: #000000;
  text-decoration: none;
`;

export { Anchor };
